import { render } from "./LegacyPageFooter.vue?vue&type=template&id=eb8e9574"
import script from "./LegacyPageFooter.vue?vue&type=script&lang=js"
export * from "./LegacyPageFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/common/LegacyPageFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eb8e9574"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eb8e9574', __exports__)) {
    api.reload('eb8e9574', __exports__)
  }
  
  module.hot.accept("./LegacyPageFooter.vue?vue&type=template&id=eb8e9574", () => {
    api.rerender('eb8e9574', render)
  })

}


export default __exports__